import styled from "styled-components";
import {
  Title,
  SubTitle,
  LARGE,
  EXTRA_LARGE,
  MOBILE,
  TABLET,
} from "@minerva-analytics/pantheon";
import {
  BODY_TEXT_COLOR,
  BACKGROUND_RIGHT_COLOR,
  BACKGROUND_COLOR,
  PRIMARY_FONT_TEXT,
  PRIMARY_COLOR,
  TITLE_FONT,
  SECONDARY_COLOR,
} from "../../theme";
import { HOME_IMAGE_MOBILE } from "../../image-links";

const HeroContainer = styled.div`
  margin: 0 3rem;
  width: 50%;
  @media (max-width: ${LARGE}) {
    width: 70%;
    text-align: left;
  }

  @media (max-width: ${TABLET}) {
    text-align: left;
    width: 85%;
  }

  @media (max-width: ${MOBILE}) {
    text-align: left;
    width: 90%;
  }
`;

const HomeTitle = styled(Title)`
  width: 100%;
  max-width: 34rem;
  color: ${PRIMARY_COLOR};
  @media (max-width: ${LARGE}) {
    text-align: center;
  }
`;

const HomeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: auto;
  margin-bottom: 20px;

  @media (max-width: ${LARGE}) {
    flex-direction: column;
    margin-bottom: 0;
  }

  @media (max-width: ${TABLET}) {
    width: 100%;
    margin-bottom: 0px;
  }
`;

const ImageContainer = styled.div`
  margin: 0 auto;
  text-align: center;

  @media (max-width: ${LARGE}) {
    flex-direction: column;
    width: 100%;
    background-color: ${BACKGROUND_RIGHT_COLOR};
  }

  img {
    width: auto;
    height: auto;
    max-width: 480px;

    @media (max-width: ${EXTRA_LARGE}) {
      max-width: 400px;
    }

    @media (max-width: ${TABLET}) {
      padding: 80px 0;
      content: url(${HOME_IMAGE_MOBILE});
    }
  }
`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 300px;
  margin: 0 auto;
`;

const SocialButtonContainer = styled.div`
  display: inline-flex;
  justify-content: space-between;
  padding-left: 20px;
  text-align: center;
  width: 150px;
  @media (max-width: ${MOBILE}) {
    padding-left: 0;
  }
`;

const HomeSubTitle = styled(SubTitle)`
  && {
    margin: 1.5rem 0;
    color: ${SECONDARY_COLOR};
    text-align: left;
    font-family: ${TITLE_FONT};
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 1.05px;
    text-transform: uppercase;
  }
`;

const Body = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${BODY_TEXT_COLOR};
  font-family: ${PRIMARY_FONT_TEXT};
  letter-spacing: 0.6px;
  line-height: 33px;
  text-align: left;
  max-width: 35rem;

  @media (max-width: ${MOBILE}) {
    padding-bottom: 20px;
  }
`;

const CircleImage = styled.img`
  margin-top: 0;
  width: 53px;
  padding-bottom: 25px;
`;

const BackgroundRight = styled.div`
  background-color: ${BACKGROUND_RIGHT_COLOR};
  @media (min-width: ${EXTRA_LARGE}) {
    position: fixed;
    top: 0px;
    height: 100vh;
    right: 0px;
    width: 50%;
  }
  z-index: -1;
`;

const Background = styled.div`
  background-color: ${BACKGROUND_COLOR};
  @media (min-width: ${EXTRA_LARGE}) {
    position: fixed;
    top: 0px;
    height: 100vh;
    left: 0px;
    width: 50%;
  }
  z-index: -1;
`;

export {
  HeroContainer,
  HomeContainer,
  ImageContainer,
  LinkContainer,
  SocialButtonContainer,
  HomeTitle,
  HomeSubTitle,
  Body,
  CircleImage,
  Background,
  BackgroundRight,
};
